module.exports = __webpack_public_path__ + "static/media/sbt.6eb12a64.png";